export class SearchBookingResultDto {
    BookingId: number;
}
export class SearchBookingDto {
    SearchKey: string;
    InstanceId: number;
}